"use client";
import { useContext } from "react";
import Link from "next/link";
import { FormattedMessage } from "react-intl";
import React from "react";
import LoginIcon from "@/assets/svg/login/round.svg";
import BurgerMenu from "@/assets/svg/menu/baseline.svg";
import { useTranslation } from "@/modules/i18n/i18n.hooks";
import { useSession } from "next-auth/react";
import isUserMenuDisplayedContext from "@/contexts/userMenu.context";
import isTransparentDisplayedContext from "@/contexts/transparentDiv.context";
import UserMenu from "./UserMenu";
import ResponsiveMenuContext from "@/contexts/responsiveMenu.context";
import AppLangChoice from "../AppSetLang/AppLangChoice";
import { SessionNextAuthUser } from "@/modules/user/types/user.types";
import { useGetSession } from "@/modules/auth/auth.hooks";
import Logo from "@/components/logo/Logo";
import { calendlyUrl } from "@/modules/sales/sales.consts";

const NavBar = () => {
  const { t } = useTranslation();

  const { me, isUserConnected } = useGetSession();

  const { isUserMenuDisplayed, setIsUserMenuDisplayed } = useContext(
    isUserMenuDisplayedContext,
  );
  const { isTransparentDivDisplayed, setIsTransparentDivDisplayed } =
    useContext(isTransparentDisplayedContext);

  const handleDisplayUserMenu = () => {
    setIsTransparentDivDisplayed(true);
    setIsUserMenuDisplayed(!isUserMenuDisplayed);
  };

  const { isResponsiveMenuDisplayed, setIsResponsiveMenuDisplayed } =
    useContext(ResponsiveMenuContext);

  return (
    <nav className="mb12 p-4 shadow-md">
      <div className="flex max-w-[80%] mx-auto">
        <Link href="/" passHref>
          <div className="w-3/12 flex justify-start items-center">
            <div className="hover:bg-slate-200 py-1 px-3 rounded-sm">
              <Logo />
            </div>
          </div>
        </Link>
        <div className="w-9/12 flex items-center justify-end">
          <Link href="/pricing" passHref>
            <div className="hidden lg:!flex hover:bg-slate-200 rounded-sm py-1 px-3 mr-5 cursor-pointer">
              <p className="text-base">
                <FormattedMessage
                  id="navbar.button.pricing"
                  defaultMessage="Pricing"
                />
              </p>
            </div>
          </Link>
          <div className="hidden lg:!flex items-center">
            <Link href={calendlyUrl} passHref target="_blank">
              <div
                className="
                            inline-flex items-center justify-center
                            px-4 py-2
                            rounded-lg
                            text-white font-semibold
                            !bg-blue-700 hover:!bg-blue-800
                            shadow-md hover:shadow-lg
                            ring-1 ring-blue-600/30
                            focus:outline-none focus:ring-4 focus:ring-blue-300
                            transition
                            mr-3 cursor-pointer
                          "
              >
                <p className="text-base">
                  <FormattedMessage
                    id="generic.demo.calendly"
                    defaultMessage="Demo"
                  />
                </p>
              </div>
            </Link>
            <Link href="/demo" passHref>
              <div className="hover:bg-slate-200 py-1 px-3 rounded-sm mr-3 cursor-pointer">
                <p className="text-base">
                  <FormattedMessage
                    id="navbar.button.demo"
                    defaultMessage="Try"
                  />
                </p>
              </div>
            </Link>
            {!isUserConnected && (
              <Link href="/login" passHref>
                <div className="hover:bg-slate-200 py-1 px-3 rounded-sm mr-3 cursor-pointer">
                  <LoginIcon
                    className=""
                    title={t("navbar.button.login", "Login")}
                  />
                </div>
              </Link>
            )}
            {isUserConnected && (
              <div className="mr-3 cursor-pointer hover:bg-slate-200 py-1 px-3 rounded-sm relative">
                <div className="" onClick={handleDisplayUserMenu}>
                  <p className="text-base">{me?.firstName}</p>
                </div>
                {isUserMenuDisplayed && <UserMenu />}
              </div>
            )}

            <AppLangChoice />
          </div>
          <div className="sm:block lg:hidden active:bg-slate-200 py-1 px-3 rounded-sm">
            <BurgerMenu
              title="Menu"
              className=""
              onClick={() =>
                setIsResponsiveMenuDisplayed(!isResponsiveMenuDisplayed)
              }
            />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
